export default {

	getSearchMonths_({ searchParams: { strDt, endDt } }) {
		return [moment(strDt).year('YYYYMMDD'), moment(endDt).year('YYYYMMDD')];
	},
};
